module.exports = __webpack_public_path__ + "static/img/wlp1260.3e5af93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wlp1260.jpg
// module id = BF6/
// module chunks = 0